export const pdfPageMaxRows = 27;